import { render } from "./ngay-sinh.vue?vue&type=template&id=5f55dd6a"
import script from "./ngay-sinh.vue?vue&type=script&lang=js"
export * from "./ngay-sinh.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__